module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-barB"
  }, [_c('div', {
    staticClass: "location_title location_title_line"
  }, [_c('div', {
    staticClass: "location_number"
  }, [_c('dl', [_c('dt', {
    on: {
      "click": _vm.refreshFollow
    }
  }, [_c('a', [_vm._v("刷新")])]), _vm._v(" "), _c('dd', [_c('span', {
    staticClass: "sp_line",
    class: {
      active: _vm.showType === 0
    },
    on: {
      "click": _vm.showAll
    }
  }, [_vm._v("总数："), _c('a', [_vm._v(_vm._s(_vm.itemObj.total) + "辆 ")])]), _vm._v(" "), _c('span', {
    staticClass: "sp_line",
    class: {
      active: _vm.showType === 1
    },
    on: {
      "click": _vm.onlineOnly
    }
  }, [_vm._v("在线："), _c('a', [_vm._v(_vm._s(_vm.itemObj.online) + "辆")])]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.showType === 2
    },
    on: {
      "click": _vm.offlineOnly
    }
  }, [_vm._v("离线："), _c('a', [_vm._v(_vm._s(_vm.itemObj.offline) + "辆")])]), _vm._v(" "), _c('span', {
    staticClass: "sp_line",
    class: {
      active: _vm.showType === 3
    },
    on: {
      "click": _vm.runOnly
    }
  }, [_vm._v("行驶中："), _c('a', [_vm._v(_vm._s(_vm.itemObj.running) + "辆")])]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.showType === 4
    },
    on: {
      "click": _vm.stopOnly
    }
  }, [_vm._v("停车中："), _c('a', [_vm._v(_vm._s(_vm.itemObj.parking) + "辆")])]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.showType === 5
    },
    on: {
      "click": _vm.unknownOnly
    }
  }, [_vm._v("未知："), _c('a', [_vm._v(_vm._s(_vm.itemObj.unknown) + "辆")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "location_btn"
  }, [_c('dl', [_c('dt', [_c('span', [_vm._v("筛选：" + _vm._s(_vm.showStatus)), _c('a', {
    on: {
      "click": _vm.showAll
    }
  }, [_vm._v("取消筛选")])])]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("批量处理：")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.operateType === 0
    },
    on: {
      "click": _vm.traceAll
    }
  }, [_c('a', {
    staticClass: "ico07"
  }, [_vm._v("跟踪")])]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.operateType === 1
    },
    on: {
      "click": _vm.locateAll
    }
  }, [_c('a', {
    staticClass: "ico01"
  }, [_vm._v("定位")])]), _vm._v(" "), (_vm.permission.indexOf('monitorVehicle_trace') == -1) ? _c('span', {
    class: {
      active: _vm.operateType === 3
    },
    on: {
      "click": _vm.trackAll
    }
  }, [_c('a', {
    staticClass: "ico03"
  }, [_vm._v("轨迹")])]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.operateType === 4
    },
    on: {
      "click": _vm.removeAll
    }
  }, [_c('a', {
    staticClass: "ico04"
  }, [_vm._v("移出")])]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.operateType === 6
    },
    on: {
      "click": _vm.outputAll
    }
  }, [_c('a', {
    staticClass: "ico06"
  }, [_vm._v("导出")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-rowB"
  }, [_c('div', {
    staticClass: "location_table"
  }, [_c('table', {
    staticClass: "table mb0px table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.infoArr), function(listItem, index) {
    return _c('tr', {
      key: listItem.vehicleId,
      staticClass: "list-complete-item",
      staticStyle: {
        "-moz-user-select": "none",
        "-ms-user-select": "none",
        "-webkit-user-select": "none"
      },
      on: {
        "click": function($event) {
          return _vm.locating(listItem.deviceId)
        },
        "dblclick": function($event) {
          return _vm.goFile(listItem.plateNumber, listItem.vehicleId)
        }
      }
    }, [_c('td', {
      staticClass: "hand",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.stopFollowing(listItem.vehicleId, index)
        }
      }
    }, [_vm._v("取消关注")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.plateNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.vehicleAccount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.serviceEndTimeStr))]), _vm._v(" "), _c('td', {
      staticClass: "hand"
    }, [_c('span', [_vm._v(_vm._s(listItem.wifiFlagStr))]), _vm._v(" | \n\t\t\t\t\t\t\t\t"), (listItem.wifiFlagStr === '无线') ? _c('span', {
      class: {
        red: listItem.wifiFlagStr === '无线' && listItem.power < 20
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/project/images/map/map_icon_c0.png")
      }
    }), _vm._v(_vm._s(listItem.power) + "%")]) : _vm._e(), _vm._v(" "), (listItem.wifiFlagStr === '无线') ? _c('span', [_vm._v(" |")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": _vm.switchLocMode(listItem.locModeStr),
        "tip": _vm.switchLocMode(listItem.locModeStr)
      }
    }, [_vm._v(_vm._s(listItem.locModeStr))]), _vm._v(" | \n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": listItem.momentTime,
        "tip": listItem.momentTime
      }
    }, [_vm._v(_vm._s(listItem.status))]), _vm._v(" "), _c('span', {
      staticClass: "tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": listItem.deviceTotalContent,
        "tip": listItem.deviceTotalContent
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showStatusList(listItem.vehicleId, listItem.plateNumber, listItem.vehicleAccount)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/project/images/map/map_icon_93.png")
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "hand"
    }, [_c('span', {
      staticClass: "tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": '活动时间：' + listItem.receiveTime,
        "tip": '活动时间：' + listItem.receiveTime
      }
    }, [_vm._v(_vm._s(listItem.receiveTimeStr))]), _vm._v(" "), _c('span', {
      staticClass: "tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": '定位时间：' + listItem.gpsTime,
        "tip": '定位时间：' + listItem.gpsTime
      }
    }, [_vm._v(_vm._s(listItem.gpsTimeStr))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.receiveTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.activeTimeStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.speed) + "km")]), _vm._v(" "), _c('td', {
      staticClass: "hand t_center tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "right",
        "title": listItem.directionName,
        "tip": listItem.directionName
      }
    }, [_c('span', {
      staticClass: "fa",
      class: _vm.switchStrToArr(listItem.directionName)
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.todayMileageKm) + "km")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.monthMileageKm) + "km")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.totalMileageKm) + "km")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicleStatus(listItem.accStop)))]), _vm._v(" "), _c('td', {
      staticClass: "hand tip",
      attrs: {
        "data-toggle": "seltip",
        "data-placement": "top",
        "title": listItem.address,
        "tip": listItem.address
      }
    }, [_c('div', {
      staticClass: "ellip"
    }, [_vm._v(_vm._s(listItem.address))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.path))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listItem.updateTimeStr))]), _vm._v(" "), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.track(listItem.vehicleId)
        }
      }
    }, [_vm._v("跟踪")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.locating(listItem.deviceId)
        }
      }
    }, [_vm._v("定位")]), _vm._v(" "), (_vm.permission.indexOf('monitorVehicle_carListDetail') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addTab(listItem.plateNumber, listItem.vehicleId)
        }
      }
    }, [_vm._v("档案")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), (_vm.infoArr.length != 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfos
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("车牌号")]), _vm._v(" "), _c('th', [_vm._v("服务号")]), _vm._v(" "), _c('th', [_vm._v("服务截至")]), _vm._v(" "), _c('th', [_vm._v("主设备状态")]), _vm._v(" "), _c('th', [_vm._v("活动（定位）时间")]), _vm._v(" "), _c('th', [_vm._v("服务器时间")]), _vm._v(" "), _c('th', [_vm._v("初次定位时间")]), _vm._v(" "), _c('th', [_vm._v("时速")]), _vm._v(" "), _c('th', [_vm._v("方向")]), _vm._v(" "), _c('th', [_vm._v("当前地区")]), _vm._v(" "), _c('th', [_vm._v("日里程")]), _vm._v(" "), _c('th', [_vm._v("月里程")]), _vm._v(" "), _c('th', [_vm._v("总里程")]), _vm._v(" "), _c('th', [_vm._v("ACC状态")]), _vm._v(" "), _c('th', {
    staticClass: "ellip"
  }, [_vm._v("地址详情")]), _vm._v(" "), _c('th', [_vm._v("机构详情")]), _vm._v(" "), _c('th', [_vm._v("刷新时间")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b0d115c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/VehicleFollow.vue
// module id = 1583
// module chunks = 0